import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import IconBase from './IconBase';
import { jsx as _jsx } from "react/jsx-runtime";

var Play = function Play(props) {
  return /*#__PURE__*/_jsx(IconBase, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      id: "Page-1",
      stroke: "none",
      fill: "none",
      children: /*#__PURE__*/_jsx("g", {
        id: "product-3",
        transform: "translate(-1054.000000, -1186.000000)",
        fill: "#FFFFFF",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group-10-Copy-2",
          transform: "translate(1032.000000, 1168.000000)",
          children: /*#__PURE__*/_jsx("g", {
            id: "Group-7",
            transform: "translate(21.500000, 18.000000)",
            children: /*#__PURE__*/_jsx("polygon", {
              id: "Triangle",
              transform: "translate(4.750000, 6.000000) rotate(-270.000000) translate(-4.750000, -6.000000) ",
              points: "4.75 2 10.0833333 10 -0.583333333 10"
            })
          })
        })
      })
    })
  }));
};

export default Play;